import VrrCard from './VrrCard';

export default VrrCard;
